// The Machines list's view state, read from and written to the URL (#6560, owner ruling
// G10): the reactive half of `parseFleetView` / `fleetViewParams` (`./fleet-machines`),
// and the List view's `page` (#6561, `./fleet-pager`). A write REPLACES the history entry,
// so a chip press or a search does not stack Back steps; a default value clears its key,
// so the plain page keeps a plain URL.
//
// THE ONE WRITE SEAM FOR THE PAGE RESET. Every view change (a chip, a tile, View server, a
// header press, a search commit) is a `setView`, and `setView` sends the page back to one
// when the question changed (`pageAfter`). So the reset is decided here, at the write,
// never in an effect watching the url: `setSearchParams` merges, so a write that left
// `page` out would keep a stale page under a new question.

import { useSearchParams } from '@solidjs/router';
import { createMemo } from 'solid-js';
import { type FleetViewState, fleetViewParams, parseFleetView } from './fleet-machines';
import { pageAfter, pageParam, parsePage } from './fleet-pager';

export function useFleetView(): {
  readonly view: () => FleetViewState;
  readonly setView: (next: FleetViewState) => void;
  /** The List view's page as the url asks for it; the list clamps it on read. */
  readonly page: () => number;
  readonly setPage: (page: number) => void;
} {
  const [params, setParams] = useSearchParams();
  const view = createMemo(() => parseFleetView(params));
  const page = createMemo(() => parsePage(params['page']));
  return {
    view,
    page,
    setView: (next) =>
      setParams(
        { ...fleetViewParams(next), page: pageParam(pageAfter(view(), next, page())) },
        { replace: true },
      ),
    setPage: (next) => setParams({ page: pageParam(next) }, { replace: true }),
  };
}
